import React from "react";
import { PREQUAL_COLORS } from "../constants";

const scratchPayLogo = "/assets/icons/scratchpay.png";

interface IPrequalBillingOptionCardProps {
  title: string;
  icon: React.ReactNode;
  description: string;
  badgeLabel?: string;
  showScratchLockup?: boolean;
  /** Violet border treatment used on the single annual-only card. */
  highlighted?: boolean;
}

// Billing-option card from the result designs (Figma 35828-52153 /
// 35825-51279). Always carries the "Available to you" line — unavailable
// options are omitted entirely rather than rendered disabled.
export const PrequalBillingOptionCard = ({
  title,
  icon,
  description,
  badgeLabel,
  showScratchLockup,
  highlighted,
}: IPrequalBillingOptionCardProps) => (
  <div
    className="relative w-full rounded-[20px] border-2 bg-white p-6 text-left sm:w-[292px]"
    style={{
      borderColor: highlighted ? PREQUAL_COLORS.cardBorderHighlight : PREQUAL_COLORS.cardBorder,
    }}
  >
    <span
      className="flex h-10 w-10 items-center justify-center rounded-[10px]"
      style={{ backgroundColor: PREQUAL_COLORS.iconChip, color: PREQUAL_COLORS.iconGold }}
    >
      {icon}
    </span>
    {badgeLabel ? (
      <span
        className="geograph-medium absolute right-6 top-6 flex h-6 items-center rounded-full
          px-2.5 text-[10px] font-medium tracking-wide text-white"
        style={{ backgroundColor: PREQUAL_COLORS.violet }}
      >
        {badgeLabel}
      </span>
    ) : null}
    <div className="mt-6 flex items-end gap-1">
      <span
        className="grenette-pro text-[20px] font-semibold leading-tight"
        style={{ color: PREQUAL_COLORS.textDark }}
      >
        {title}
      </span>
      {showScratchLockup ? (
        <span className="geograph-medium mb-0.5 flex items-center gap-1 text-[10px] text-black">
          Powered by
          <img src={scratchPayLogo} alt="ScratchPay" className="h-3" />
        </span>
      ) : null}
    </div>
    <p
      className="geograph-regular mt-1 text-[14px] leading-normal"
      style={{ color: PREQUAL_COLORS.textMuted }}
    >
      {description}
    </p>
    <span
      className="geograph-medium mt-4 inline-block text-[14px]"
      style={{ color: PREQUAL_COLORS.teal }}
    >
      ✓ Available to you
    </span>
  </div>
);
